
import Vue from 'vue'

export default Vue.extend({
  name: 'JourneyTreeNode',
  props: {
    node: { type: Object, required: true }
  },
  inject: ['journey'],
  data () {
    return { open: (this as any).node.expanded !== false }
  },
  watch: {
    'journey.collapseLicTick' () {
      if (this.node.type === 'Licence') this.open = false
    },
    'journey.expandTick' () { this.open = true }
  },
  computed: {
    hasChildren (): boolean {
      return !!(this.node.children && this.node.children.length)
    },
    isSelected (): boolean {
      return (this as any).journey.selectedNodeId === this.node.id
    }
  },
  methods: {
    toggle () { this.open = !this.open },
    select () { (this as any).journey.selectNode(this.node) }
  }
})
